import { render, staticRenderFns } from "./LmPassengerActivities.vue?vue&type=template&id=6e4688fe&scoped=true"
import script from "./LmPassengerActivities.vue?vue&type=script&lang=js"
export * from "./LmPassengerActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4688fe",
  null
  
)

export default component.exports